import { createContext } from 'react';
import { IApiService } from '../../api/IApiService';

const ApiServiceContext = createContext<IApiService|undefined>(undefined);

export default ApiServiceContext;